import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PermissionsService } from '../permissions/permissions.service';
import { UserService } from '../user/user.service';

@Injectable()
export class PasswordChangeGuardService {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
        private userService: UserService,
    ) {}

    public canActivate(): boolean {
        if (
            !this.permissionsService.checkPermission({
                name: 'password_change',
                user: this.userService.current_profile._id,
            })
        ) {
            this.router.navigate(['/error/403']);
            return false;
        }

        return true;
    }
}
